import { render, staticRenderFns } from "./NewMain.vue?vue&type=template&id=2599941e&scoped=true&"
import script from "./NewMain.vue?vue&type=script&lang=ts&"
export * from "./NewMain.vue?vue&type=script&lang=ts&"
import style0 from "./NewMain.vue?vue&type=style&index=0&id=2599941e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599941e",
  null
  
)

export default component.exports